<template>
    <div class="text-center">
      <v-dialog v-model="dialog" persistent>
        <v-card>
          <v-card-title class="text-h5 blue lighten-0 darken-4 white--text">
            Crear un nuevo periodo:
          </v-card-title>
  
          <v-card-text>   
            <p class="text-center mt-6 green--text">Complete la informacion para registrar un nuevo periodo de seleccion:</p>
            <div class="row justify-center"> 
              <!-- <div class="col-xs-12 col-sm-4 col-xl-1">
                <v-select v-model="input.tipo_periodo" item-value="id" :items="tipos" label="tipo de periodo:" />
              </div> -->
              <div class="col-xs-12 col-sm-5 col-lg-3 col-xl-1 mx-5">
                <v-text-field label="Fecha inicio:" v-model="input.fecha_inicio"  type="datetime-local" prefix="desde:" hide-details />
              </div>
              <div class="col-xs-12 col-sm-5 col-lg-3 col-xl-1">
                  <v-text-field label="Fecha fin:" v-model="input.fecha_final"  type="datetime-local" prefix="hasta:" hide-details />
              </div> 
            </div> 
            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>            
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" :disabled="loading" outlined @click="enviar()"> Enviar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
import { crear_periodoSeleccion } from '@/views/oferta_academica/servicios/seleccionService.ts';


  export default {
      data() {
        return {
          loading: true,
          dialog: false,
          tipos:[{id:'SELECCION', text:'Periodo de seleccion de programas'}],
          input: {},
        };
      }, 
      methods: {
        async openmodal() {
            this.input = {};
            this.input.tipo_periodo = this.tipos[0].id;
            this.input.unidad_negocio_id = this.$store.state.CARGO.sede.unidad_negocio;
            this.input.creado_por_id = this.$store.state.DATA_USER.id;
            this.loading = false;
            this.dialog = true;  
                
        },
        cerrar() { 
            this.dialog = false;
        },
        validarFechas(fechaInicio, fechaFinal) {
            const inicio = new Date(fechaInicio);
            const final = new Date(fechaFinal);
            if (final > inicio) return true;
            else return false;
        },
        async enviar(){ 
            let msg = ''
            if(!this.input.fecha_final) msg = 'ingrese la fecha de fin'
            if(!this.input.fecha_inicio) msg = 'ingrese la fecha inicio'
            if(!this.validarFechas(this.input.fecha_inicio,this.input.fecha_final)){
              msg = 'fecha final debe ser superior a la inicial'
              this.$root.$notify.show(msg, {color:'red',x: 'right',})
              return
            }
            if(msg){
                this.$root.$notify.show(msg, {color:'red',x: 'right',})
                return
            }


            const u = {...this.input}
            u.fecha_inicio += ':00-04:00'
            u.fecha_final += ':00-04:00'
            const r = await crear_periodoSeleccion(u)
            if(r && r.crear_periodoSeleccion){
                window.console.log('>>>', r)
                this.dialog = false
                this.$emit('success')
            }else if(r && r.graphQLErrors) {
              let m = ''
              r.graphQLErrors.forEach(x => {
                m += x.message
              });  
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }
            window.console.log('>>>', r)
            this.loading = false;
        },

         
      },
    };
  </script>
  